// file: GregorianYearList.js
import React, { useState } from "react";
import SharedHelmet from "../.././Helmet";
import imgUrl from "../../../../images/age-year.webp"
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const TITLE = `Hitung usia kelahiran tahun dari 1960 hingga ${currentYear} | Akurasi tinggi`;
const DESCRIPTION = `Hitung usia Anda sekarang dengan akurasi tinggi jika Anda termasuk kelahiran tahun antara 1960 dan ${currentYear}. Kalkulator usia terperinci yang menunjukkan jumlah tahun, bulan, dan hari sejak tanggal lahir Anda hingga hari ini. Cocok untuk kelahiran tahun 1960-an, 1970-an, 1980-an, 1990-an, 2000-an hingga ${currentYear}.`;
const KEYWORDS = `
Kalkulator usia,
Menghitung usia,
Berapa umur saya sekarang,
Usia kelahiran 1960,
Usia kelahiran 1970,
Usia kelahiran 1980,
Usia kelahiran 1990,
Usia kelahiran 2000,
Usia kelahiran 2010,
Kelahiran 1960 berapa usia mereka,
Kelahiran 1970 berapa usia mereka,
Kelahiran 1980 berapa usia mereka,
Kelahiran 1990 berapa usia mereka,
Kelahiran 2000 berapa usia mereka,
Kelahiran 2010 berapa usia mereka,
Berapa usia kelahiran 1960,
Berapa usia kelahiran 1970,
Berapa usia kelahiran 1980,
Berapa usia kelahiran 1990,
Berapa usia kelahiran 2000,
Berapa usia kelahiran 2010,
Menghitung usia dalam tahun, bulan, dan hari,
Usia kelahiran dari 1960 hingga ${currentYear}
`.trim();
const OG_URL = "https://do-calculate.com/calculator/id/gregorian/gregorian-year-list/";
function GregorianYearsList() {
    const [searchTerm, setSearchTerm] = useState("");
    const years = Array.from({ length: currentYear - 1960 + 1 }, (_, i) => 1960 + i);
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredYears = years.filter(year =>
        year.toString().includes(searchTerm)
    );
    return (
        <div className="container " >
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                OG_IMAGE={imgUrl}
            />
            <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
            <hr />
            <div className="alert alert-secondary" role="alert">
                <p>{DESCRIPTION}</p>
            </div>
            <hr />
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "15px",
                }}
            >
                <h2 style={{ margin: 0 }}>Cari tahun kelahiran</h2>
                <input
                    type="text"
                    placeholder="Cari tahun..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        width: "200px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                />
            </div>
            <table className="bmi-table" style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th >Tahun kelahiran</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredYears.map((year, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <a href={`/calculator/id/gregorian/${year}/`}>
                                        Kelahiran tahun {year}
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="mt-4 p-3 bg-light rounded">
                <h3>Cara menggunakan kalkulator:</h3>
                <ul>
                    <li>Pilih tahun kelahiran dari tabel di atas</li>
                    <li>Anda akan diarahkan ke halaman kalkulator untuk tahun tersebut</li>
                    <li>Masukkan hari dan bulan kelahiran untuk mengetahui usia Anda secara tepat</li>
                </ul>
            </div>
        </div>
    );
}
export default GregorianYearsList;